import React,{ FC } from 'react';
import './index.scss';

const BubbleContainer:FC = ({children}) => {
    return <div className="bubble-popup-container">
        {children}
    </div>
}

export default BubbleContainer;